import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12 54.5c-.85 0-1.563-.288-2.137-.862C9.288 53.063 9 52.35 9 51.5c0-.85.287-1.563.863-2.138.575-.575 1.287-.862 2.137-.862h48c.85 0 1.563.288 2.138.862.575.575.862 1.288.862 2.138 0 .85-.288 1.563-.862 2.138-.575.575-1.288.862-2.138.862H12Zm0-15c-.85 0-1.563-.288-2.137-.862C9.288 38.063 9 37.35 9 36.5c0-.85.287-1.563.863-2.138.575-.575 1.287-.862 2.137-.862h48c.85 0 1.563.288 2.138.862.575.575.862 1.288.862 2.138 0 .85-.288 1.563-.862 2.138-.575.575-1.288.862-2.138.862H12Zm0-15c-.85 0-1.563-.288-2.137-.863C9.288 23.063 9 22.35 9 21.5c0-.85.287-1.563.863-2.137.575-.575 1.287-.863 2.137-.863h48c.85 0 1.563.288 2.138.863S63 20.65 63 21.5c0 .85-.288 1.563-.862 2.137-.575.575-1.288.863-2.138.863H12Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "hamburger"}) } }